(ns manage.adset-template-page.db.db
  (:require [common.db.interceptors :refer [forwarded-event]]
            [common.util :refer [format-timestamp]]
            [re-frame.core :as rf]))

(defn get-by-id
  [coll id]
  (first (filter #(= (:id %) id) coll)))

(defn revision->label
  [{:keys [version updatedAt]}]
  (str version " (" (format-timestamp updatedAt) ")"))

(rf/reg-event-fx :page.adset-template/init
  (fn []
    {:fx [[:forward-events [{:register :upgrade-hints-success
                             :events #{:resource.template/upgrade-hints-success}
                             :dispatch-to [:page.adset-template/upgrade-hints-success]}]]
          [:dispatch [:assemble.resource.asset-tree/list-folders]]
          [:dispatch [:resource.template/upgrade-hints]]]}))

(rf/reg-event-fx :page.adset-template/destroy
  (fn [_ _]
    {:fx [[:forward-events [{:unregister :upgrade-hints-success}]]]}))

(rf/reg-event-db :page.adset-template/init-revision-ocp
  (fn [db [_ template]]
    (assoc-in db [:page.adset-template :current-template] template)))

(rf/reg-event-fx :page.adset-template/set-revision
  [(rf/inject-cofx :sub :page.adset-template/revisions)]
  (fn [{:keys [db]
        :page.adset-template/keys [revisions]} [_ {:keys [template revision-id]}]]
    (let [revisions-for-template (get-by-id revisions (:id template))
          revisions* (vector (:currentRevision revisions-for-template)
                             (:latestRevision revisions-for-template))
          revision (get-by-id revisions* revision-id)
          template* (-> template
                        (assoc :revisionIds (vector revision-id))
                        (assoc :revisions (vector revision)))]
      {:db (assoc-in db [:page.adset-template :current-template] template*)})))

(rf/reg-event-db :page.adset-template/upgrade-hints-success
  [forwarded-event]
  (fn [db [_ revisions]]
    (assoc-in db [:page.adset-template :revisions] revisions)))

(rf/reg-sub :page.adset-template
  (fn [db _]
    (:page.adset-template db)))

(rf/reg-sub :page.adset-template/current-template
  :<- [:page.adset-template]
  (fn [adset-template-db _]
    (:current-template adset-template-db)))

(rf/reg-sub :page.adset-template/revisions
  :<- [:page.adset-template]
  (fn [adset-template-db _]
    (:revisions adset-template-db)))

(rf/reg-sub :page.adset-template/revision-options
  :<- [:page.adset-template/revisions]
  (fn [revisions [_ id]]
    (let [revision (get-by-id revisions id)
          revisions* (cond-> (conj [] (:currentRevision revision))
                       (not= (:currentRevision revision) (:latestRevision revision)) (conj (:latestRevision revision)))] ; Will be changed to all revisions in LPDEV2-723
      (doall (map (fn [{:keys [id] :as revision*}]
                    {:label (revision->label revision*)
                     :value id}) revisions*)))))

(rf/reg-sub :page.adset-template/new-revision?
  :<- [:page.adset-template/revisions]
  (fn [revisions [_ template-id]]
    (let [revisions-by-id (first (filter #(= template-id (:id %)) revisions))]
      (not= (get-in revisions-by-id [:currentRevision :id])
            (get-in revisions-by-id [:latestRevision :id])))))

(rf/reg-sub :page.adset-template/old-revision
  :<- [:page.adset-template/revisions]
  (fn [revisions [_ template-id]]
    (let [revisions-by-id (first (filter #(= template-id (:id %)) revisions))]
      (:currentRevision revisions-by-id))))

(rf/reg-sub :page.adset-template/latest-revision
  :<- [:page.adset-template/revisions]
  (fn [revisions [_ template-id]]
    (let [revisions-by-id (first (filter #(= template-id (:id %)) revisions))]
      (:latestRevision revisions-by-id))))
